import { useCallback, useState } from "react";

export default function useGetTrustTransferDeedTemplateData() {
  const [
    isLoadingTrustTransferDeedTemplate,
    setIsLoadingTrustTransferDeedTemplate,
  ] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchTrustTransferDeed = useCallback(
    async (trustId: string, trustName: string) => {
      let url = `https://hometrustapi.azurewebsites.net/api/v2/Templates/generate/TrustTransferDeed/${trustId}`;

      setIsLoadingTrustTransferDeedTemplate(true);
      setError(null);

      console.log("getting Templates");
      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(
            `Failed to download document: ${response.statusText}`,
          );
        }

        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = `${trustName}_TrustTransferDeed.zip`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      } catch (error: any) {
        console.error("Error downloading file:", error);
        setError(error);
      } finally {
        setIsLoadingTrustTransferDeedTemplate(false);
      }
    },
    [],
  );

  return { isLoadingTrustTransferDeedTemplate, error, fetchTrustTransferDeed };
}
